import { React, useState, useEffect, useRef } from "react";
import "../../styles/ShootingStars.css";
import { TbBrandReact } from "react-icons/tb";
import { RiNextjsFill } from "react-icons/ri";
import { SiSpring } from "react-icons/si";
import { RiTailwindCssLine } from "react-icons/ri";
import { SiAngular } from "react-icons/si";
import { SiIonic } from "react-icons/si";
import { BiLogoTypescript } from "react-icons/bi";
import { TbBrandJavascript } from "react-icons/tb";
import { RiJavaLine } from "react-icons/ri";
import { SiKotlin } from "react-icons/si";
import { FaNodeJs } from "react-icons/fa";
import { IoLogoPython } from "react-icons/io5";
import { FaGithub } from "react-icons/fa";
import { IoLogoDocker } from "react-icons/io5";
import { IoLogoBitbucket } from "react-icons/io5";
import { SiMysql } from "react-icons/si";
import { SiJira } from "react-icons/si";
import { PiFigmaLogoBold } from "react-icons/pi";
import { FaHubspot } from "react-icons/fa";
export default function About() {
  const [frontendOpen, setFrontendOpen] = useState(false);
  const [backendOpen, setBackendOpen] = useState(false);
  const [otherOpen, setOtherOpen] = useState(false);

  const frontendRef = useRef(null);
  const backendRef = useRef(null);
  const otherRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (frontendRef.current && !frontendRef.current.contains(event.target)) {
        setFrontendOpen(false);
      }
      if (backendRef.current && !backendRef.current.contains(event.target)) {
        setBackendOpen(false);
      }
      if (otherRef.current && !otherRef.current.contains(event.target)) {
        setOtherOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const renderShootingStars = () => {
    return Array.from({ length: 30 }).map((_, index) => {
      const randomTop = Math.random() * window.innerHeight;
      const randomLeft = Math.random() * window.innerWidth;
      const randomDelay = Math.random() * 9999;

      const starStyle = {
        top: `${randomTop}px`,
        left: `${randomLeft}px`,
        animationDelay: `${randomDelay}ms`,
      };

      return <div key={index} className="shooting_star" style={starStyle} />;
    });
  };

  return (
    <div className="about-container bg-gray-900 py-16" >
      <div className="night-background">
        <div className="night">{renderShootingStars()}</div>
      </div>

      <main className="relative z-10">
        <div className="overflow-hidden">
          <div className="mx-auto max-w-7xl py-16 sm:py-24 lg:py-32 px-6 lg:px-8">
            <h1 className="text-white text-5xl mb-8">My Skills 🛠️</h1>
            <div className="flex flex-col lg:flex-row items-center justify-between gap-x-12">
              <div className="text-left lg:w-1/2">
                <p className="mt-6 text-lg leading-8 text-white">
                I build strong, scalable applications that prioritize user experience and performance.
                </p>
                <p className="mt-6 text-lg leading-8 text-white sm:max-w-md lg:max-w-none">
                I have a strong foundation in both frontend and backend development, allowing me to create complete web applications from start.
                </p>  
                <p className="mt-6 text-lg leading-8 text-white sm:max-w-md lg:max-w-none">
                On the frontend, I work proficiently with NextJS, React, and Angular, utilizing these powerful frameworks for Frontend and Fullstack development.
                </p>
                <p className="mt-6 text-lg leading-8 text-white sm:max-w-md lg:max-w-none">
                For backend development, I am proficient in Javascript, Java, Node, and Kotlin.
                </p>

              </div>
              <div className="flex flex-col gap-4 lg:mt-0 lg:w-1/2 justify-center lg:justify-end ml-18">
                <div ref={frontendRef} className="relative">
                  <button
                    onClick={() => setFrontendOpen(!frontendOpen)}
                    className="text-white bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 hover:from-pink-500 hover:via-purple-500 hover:to-indigo-500 transition-all duration-300 font-medium rounded-lg text-lg px-12 py-3 text-center inline-flex items-center justify-between w-[32rem] shadow-lg hover:shadow-xl"
                    type="button"
                  >
                    FRONTEND
                    <svg
                      className={`w-4 h-4 ms-3 transition-transform duration-200 ${
                        frontendOpen ? "rotate-180" : ""
                      }`}
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 10 6"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 1 4 4 4-4"
                      />
                    </svg>
                  </button>

                  <div
                    className={`absolute z-10 ${
                      frontendOpen ? "block" : "hidden"
                    } mt-2 bg-white divide-y divide-gray-100 rounded-lg shadow w-[32rem] dark:bg-gray-700`}
                    style={{ maxHeight: '300px', overflowY: 'auto' }}
                  >
                    <ul className="py-3 text-base text-gray-700 dark:text-gray-200">
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                        <TbBrandReact className="text-2xl" /> React
                      </li>
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                        <RiNextjsFill className="text-2xl" /> Next.js
                      </li>
                      
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                        <RiTailwindCssLine className="text-2xl" /> Tailwind CSS
                      </li>
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                        <SiAngular className="text-2xl" /> Angular
                      </li>
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                        <SiIonic className="text-2xl" /> Ionic
                      </li>
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                      <BiLogoTypescript className="text-2xl" /> TypeScript
                      </li>
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                      <FaHubspot className="text-2xl" /> Hubspot
                      </li>
                    </ul>
                  </div>
                </div>
                <div ref={backendRef} className="relative mt-14">
                  <button
                    onClick={() => setBackendOpen(!backendOpen)}
                    className="text-white bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500 hover:from-purple-500 hover:via-indigo-500 hover:to-blue-500 transition-all duration-300 font-medium rounded-lg text-lg px-12 py-3 text-center inline-flex items-center justify-between w-[32rem] shadow-lg hover:shadow-xl"
                    type="button"
                  >
                    BACKEND
                    <svg
                      className={`w-4 h-4 ms-3 transition-transform duration-200 ${
                        backendOpen ? "rotate-180" : ""
                      }`}
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 10 6"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 1 4 4 4-4"
                      />
                    </svg>
                  </button>

                  <div
                    className={`absolute z-10 ${
                      backendOpen ? "block" : "hidden"
                    } mt-2 bg-white divide-y divide-gray-100 rounded-lg shadow w-[32rem] dark:bg-gray-700`}
                    style={{ maxHeight: '300px', overflowY: 'auto' }}
                  >
                    <ul className="py-3 text-base text-gray-700 dark:text-gray-200">
                    <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                    <TbBrandJavascript className="text-2xl" />Javascript
                      </li>
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                      <RiJavaLine className="text-2xl" /> Java
                      </li>
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                      <FaNodeJs className="text-2xl" /> Node.js
                      </li>
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                      <SiKotlin className="text-2xl" /> Kotlin
                      </li>
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                        <SiSpring className="text-2xl" /> SpringBoot
                      </li>
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                      <IoLogoPython className="text-2xl" /> Python
                      </li>
                      
                    </ul>
                  </div>
                </div>
                <div ref={otherRef} className="relative mt-14">
                  <button
                    onClick={() => setOtherOpen(!otherOpen)}
                    className="text-white bg-gradient-to-r from-cyan-500 via-indigo-500 to-yellow-500 hover:from-purple-500 hover:via-teal-500 hover:to-cyan-500 transition-all duration-300 font-medium rounded-lg text-lg px-12 py-3 text-center inline-flex items-center justify-between w-[32rem] shadow-lg hover:shadow-xl"
                    type="button"
                  >
                    OTHER
                    <svg
                      className={`w-4 h-4 ms-3 transition-transform duration-200 ${
                        otherOpen ? "rotate-180" : ""
                      }`}
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 10 6"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 1 4 4 4-4"
                      />
                    </svg>
                  </button>

                  <div
                    className={`absolute z-10 ${
                      otherOpen ? "block" : "hidden"
                    } mt-2 bg-white divide-y divide-gray-100 rounded-lg shadow w-[32rem] dark:bg-gray-700`}
                    style={{ maxHeight: '500px', overflowY: 'auto' }}
                  >
                    <ul className="py-3 text-base text-gray-700 dark:text-gray-200">
                    <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                        <FaGithub className="text-2xl" /> Git
                      </li>
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                        <IoLogoDocker className="text-2xl" /> Docker
                      </li>
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                        <IoLogoBitbucket className="text-2xl" /> Bitbucket
                      </li>
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                        <SiMysql className="text-2xl" /> MySQL
                      </li>
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                        <SiJira className="text-2xl" /> Jira
                      </li>
                      <li className="px-12 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 cursor-pointer flex items-center gap-3">
                        <PiFigmaLogoBold className="text-2xl" /> Figma
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
